import { createMetricsFactory } from 'metrics-js';
import { readUnhandledEnumCase } from 'rpc-client-utils';
export const UIAUMetrics = createMetricsFactory('ui-addon-upgrades', {
  library: 'ui-addon-upgrades'
});
export const PurchaseMotionsComponentsMetrics = createMetricsFactory('purchase-motions-components', {
  library: 'purchase-motions-components'
});
export const PPUIMetrics = createMetricsFactory('pricing-pages-ui');
export const trackTrialActivation = ({
  apiName,
  app,
  trialName
}) => {
  // matches existing UIAU tracker, https://git.hubteam.com/HubSpot/ui-addon-upgrades/blob/a768d23781caa55713e3862dfcf8eae6193f105f/ui-addon-upgrades/static/js/_core/utils/metricUtils.ts#L40-L45
  UIAUMetrics.counter('trial-activation', {
    app,
    apiName,
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('trial-activation', {
    app,
    apiName,
    trialName
  }).increment();
};
export const trackPurchaseMotionFailure = ({
  uniqueId,
  apiName,
  purchaseMotion
}) => {
  UIAUMetrics.counter('purchase-motion-failure', {
    uniqueId,
    apiName,
    purchaseMotion: readUnhandledEnumCase(purchaseMotion),
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('purchase-motion-failure', {
    uniqueId,
    apiName,
    purchaseMotion: readUnhandledEnumCase(purchaseMotion)
  }).increment();
};
export const incrementPurchaseOrderGenerationSuccess = apiNames => {
  UIAUMetrics.counter('purchase-order-generation-success', {
    type: 'buy-touchless',
    apiNames: JSON.stringify(apiNames),
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('purchase-order-generation-success', {
    apiNames: JSON.stringify(apiNames)
  }).increment();
};
export const incrementPurchaseOrderGenerationFailure = apiNames => {
  UIAUMetrics.counter('purchase-order-generation-failure', {
    type: 'buy-touchless',
    apiNames: JSON.stringify(apiNames),
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('purchase-order-generation-failure', {
    apiNames: JSON.stringify(apiNames)
  }).increment();
};
export const trackPqlFailure = app => {
  UIAUMetrics.counter('pql-failure', {
    app,
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('pql-failure', {
    app
  }).increment();
};
export const trackTalkToSalesPql = app => {
  UIAUMetrics.counter('talk-to-sales-pql', {
    app,
    repo: 'purchase-motions-components'
  }).increment();
  PurchaseMotionsComponentsMetrics.counter('talk-to-sales-pql', {
    app
  }).increment();

  // For namespace-specific alerting monitorable by the pricing-pages team
  if (app === 'pricing-pages' || app.includes('pricing-page')) {
    PPUIMetrics.counter('talk-to-sales-pql').increment();
  }
};
export const incrementDirectToBuyConfigSuccess = apiNames => {
  PurchaseMotionsComponentsMetrics.counter('direct-to-buy-config-success', {
    apiNames: JSON.stringify(apiNames)
  }).increment();
};
export const incrementDirectToBuyConfigFailure = apiNames => {
  PurchaseMotionsComponentsMetrics.counter('direct-to-buy-config-failure', {
    apiNames: JSON.stringify(apiNames)
  }).increment();
};
export const trackCommModalView = (cohort, app) => {
  PurchaseMotionsComponentsMetrics.counter('comm-modal-view', {
    cohort,
    app
  }).increment();
};
export const trackSelfServiceEligibilityResult = (result, errorType) => {
  PurchaseMotionsComponentsMetrics.counter('self-service-eligibility-result', Object.assign({
    result
  }, errorType ? {
    errorType
  } : {})).increment();
};